var _effectorFileName = "/builds/gmini/front-ui-kit/src/Box/Box.tsx";
import { BoxWrapper } from './Box.styled'; //закомменчены пропсы которые не используются на проекте, но в material-ui доке есть и реализовать их можно
//для всех активных пропсов реализация написана

import { jsx as _jsx } from "react/jsx-runtime";
export const Box = props => /*#__PURE__*/_jsx(BoxWrapper, {
  as: props.component,
  ...props,
  children: props.children
});